import type { ReactElement, ReactNode } from "react"
import {
  ThemeInverter,
  ThemeInverterContext,
} from "@ionos-web-design-system/react/theme-inverter"
import useHelThemeData from "~/hooks/useHelThemeData"

export type UdsThemeProviderProps = {
  children: ReactNode
  forceColorScheme?: "light" | "dark"
}

const udsBrand = process.env.GATSBY_UDS_BRAND || "homepl"

export default function UdsThemeProvider({
  children,
  forceColorScheme,
}: UdsThemeProviderProps): ReactElement<UdsThemeProviderProps> {
  const { isDarkOnColorValue } = useHelThemeData()
  const colorScheme =
    forceColorScheme ?? (isDarkOnColorValue ? "dark" : "light")

  return (
    <ThemeInverterContext.Provider
      value={{
        brand: udsBrand,
        platform: "comfortable",
        color: colorScheme,
        isInverted: false,
      }}
    >
      <ThemeInverter forceColorScheme={colorScheme} invert>
        {children}
      </ThemeInverter>
    </ThemeInverterContext.Provider>
  )
}
